import { defineMessages } from '@atlassian/jira-intl';

// TODO: Delete this file when cleaning up smart_fields_gic_toggle_fg
export const messages = defineMessages({
	imgAltText: {
		id: 'personal-settings-gic-smart-fields.common.img-alt-text',
		defaultMessage: 'Hide unused fields when creating issues',
		description: 'ALT text of the image next to the GIC Smart Fields Jira Labs feature',
	},
	headerText: {
		id: 'personal-settings-gic-smart-fields.common.header-text',
		defaultMessage: 'Hide unused fields when creating issues',
		description: 'Title of the GIC Smart Fields Jira Labs feature',
	},
	descriptionText: {
		id: 'personal-settings-gic-smart-fields.common.description-text',
		defaultMessage:
			'We’ve implemented some smarts to make sure you have quick and easy access to the fields you actually use when you create issues. We’re not removing the unused fields, you’ll still be able to find them in a <strong>More fields</strong> section at the bottom of the issue create form. <link>Read more about the fields available when creating issues</link>',
		description: 'This is the description to explain Smart Fields and how to disable it',
	},
	loadingIndicatorAriaLabel: {
		id: 'personal-settings-gic-smart-fields.common.loading-indicator-aria-label',
		defaultMessage: 'Loading data for smart fields toggle button',
		description: 'Loading indicator shown before the toggle button is displayed ',
	},
	errTitleOptingOut: {
		id: 'personal-settings-gic-smart-fields.common.err-title-opting-out',
		defaultMessage: 'Failed to turn off',
		description: 'Error title when opting out of Smart Fields',
	},
	errTitleOptingIn: {
		id: 'personal-settings-gic-smart-fields.common.err-title-opting-in',
		defaultMessage: 'Failed to turn on',
		description: 'Error title when opting in to Smart Fields',
	},
	errDescriptionOptingIn: {
		id: 'personal-settings-gic-smart-fields.common.err-description-opting-in',
		defaultMessage:
			'The issue should fix itself. You can try again in a few minutes, or refresh the page.',
		description: 'Error description when opting in to Smart Fields',
	},
	successTitleOptingIn: {
		id: 'personal-settings-gic-smart-fields.common.success-title-opting-in',
		defaultMessage: 'Now hiding unused fields when you create issues.',
		description: 'Success title when opting in to Smart Fields',
	},
	successTitleOptingOut: {
		id: 'personal-settings-gic-smart-fields.common.success-title-opting-out',
		defaultMessage: 'Unused fields now showing when you create issues.',
		description: 'Success title when opting out of Smart Fields',
	},
	refreshPageBtn: {
		id: 'personal-settings-gic-smart-fields.common.refresh-page-btn',
		defaultMessage: 'Refresh page',
		description: 'Refresh page button',
	},
	feedbackTitle: {
		defaultMessage: 'Share your feedback',
		id: 'personal-settings-gic-smart-fields.common.feedback-title',
		description: '',
	},
	feedbackOptOutTitle: {
		defaultMessage: 'Before you go, help us improve the experience',
		id: 'personal-settings-gic-smart-fields.common.feedback-opt-out-title',
		description: '',
	},
	toggleAriaLabel: {
		id: 'personal-settings-gic-smart-fields.common.toggle-aria-label',
		defaultMessage: 'Toggle for hiding unused fields when creating issues',
		description: 'Aria label for the toggle',
	},
	imgAltTextIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.img-alt-text-issue-term-refresh',
		defaultMessage: 'Hide unused fields when creating work items',
		description: 'ALT text of the image next to the GIC Smart Fields Jira Labs feature',
	},
	headerTextIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.header-text-issue-term-refresh',
		defaultMessage: 'Hide unused fields when creating work items',
		description: 'Title of the GIC Smart Fields Jira Labs feature',
	},
	descriptionTextIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.description-text-issue-term-refresh',
		defaultMessage:
			"We've moved fields you don't use when creating work to a <strong> More fields</strong> section below. <link>Read about the fields available when creating work</link>.",
		description: 'This is the description to explain Smart Fields and how to disable it',
	},
	errDescriptionOptingInIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.err-description-opting-in-issue-term-refresh',
		defaultMessage:
			'The issue should fix itself. You can try again in a few minutes, or refresh the page.',
		description: 'Error description when opting in to Smart Fields',
	},
	successTitleOptingInIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.success-title-opting-in-issue-term-refresh',
		defaultMessage: 'Now hiding unused fields when you create work items.',
		description: 'Success title when opting in to Smart Fields',
	},
	successTitleOptingOutIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.success-title-opting-out-issue-term-refresh',
		defaultMessage: 'Unused fields now showing when you create work items.',
		description: 'Success title when opting out of Smart Fields',
	},
	toggleAriaLabelIssueTermRefresh: {
		id: 'personal-settings-gic-smart-fields.common.toggle-aria-label-issue-term-refresh',
		defaultMessage: 'Toggle for hiding unused fields when creating work items',
		description: 'Aria label for the toggle',
	},
});
